export default __webpack_public_path__ + "static/media/TONIC.cbb9b6cf.svg";